import { render, staticRenderFns } from "./SwipeFileBrandsIcon.vue?vue&type=template&id=707b4782"
import script from "./SwipeFileBrandsIcon.vue?vue&type=script&lang=js"
export * from "./SwipeFileBrandsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports